export default [
  {
    position: "absolute",
    top: 3.8,
    left: 45,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "feedbackMore.persona1.mTitleOne",
    mBody: "feedbackMore.persona1.mBodyOne",
    isVideo: true,
    videoThumb: "OB-Feedback-Thumb",
    videoURL: "OB-Feedback.mp4",
    vidIcon: true,
    id: "OB_OnboardingSurvey_Video_MonitoringFeedback",
    index: 0,
  },
  {
    position: "absolute",
    top: 2.9,
    left: 61.8,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "feedbackMore.persona1.ttTextFour",
    hover: false,
    id: "OB_OnboardingSurvey_Navigation_Feedback",
    index: 1,
  },
];
